import { render, staticRenderFns } from "./simple-table.vue?vue&type=template&id=006dafe8&scoped=true&"
import script from "./simple-table.vue?vue&type=script&lang=js&"
export * from "./simple-table.vue?vue&type=script&lang=js&"
import style0 from "./simple-table.vue?vue&type=style&index=0&id=006dafe8&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006dafe8",
  null
  
)

export default component.exports